/**
 * Demo stubs for attendanceApi methods.
 * Returns safe empty/success responses to prevent crashes in demo mode.
 */
export const demoAttendanceService = {
  checkIn: async () => ({ success: true, message: 'Demo check-in', data: { check_in_time: '09:00', status: 'working' } }),
  checkOut: async () => ({ success: true, message: 'Demo check-out', data: { check_out_time: '18:00', status: 'checked_out' } }),
  getToday: async () => ({ success: true, data: { checked_in: false, status: 'not_checked' } }),
  updateToday: async () => ({ success: true }),
  deleteTodayAdmin: async () => ({ success: true }),
  getRecords: async () => ({ success: true, data: { items: [], total: 0 } }),
  getTeam: async () => ({ success: true, data: { members: [], summary: { total: 0, checked_in: 0, checked_out: 0, absent: 0, remote: 0 } } }),
  getEmployeeRecords: async () => ({ success: true, data: { items: [], total: 0 } }),
  getSchedules: async () => ({ success: true, data: [] }),
  createSchedule: async () => ({ success: true }),
  getOfficeNetworks: async () => ({ success: true, data: [] }),
  addOfficeNetwork: async () => ({ success: true }),
  getHolidays: async () => ({ success: true, data: [] }),
  getAnomalies: async () => ({ success: true, data: { absent: [], missing_checkout: [], late_arrival: [], overtime_risk: [] } }),
  getAuditLogs: async () => ({ success: true, data: [] }),
  exportAttendance: async () => new Blob(),
  createRemoteRequest: async () => ({ success: true }),
  getMyRemoteRequests: async () => ({ success: true, data: [] }),
  getPendingRemoteRequests: async () => ({ success: true, data: [] }),
  approveRemoteRequest: async () => ({ success: true }),
  rejectRemoteRequest: async () => ({ success: true }),
  withdrawRemoteRequest: async () => ({ success: true }),
  adminCorrection: async () => ({ success: true }),
};
